import { MenuItem, Select } from "@material-ui/core";
import { useTranslation } from "react-i18next";

interface Props {
  value: string;
  onChange: (locale: string) => void;
}

export const LocaleSelect: React.VFC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <Select value={value} onChange={e => onChange(e.target.value as string)} variant="outlined">
      <MenuItem value="sv-SE">{t("exercises.locale.sv_se")}</MenuItem>
      <MenuItem value="en-SE">{t("exercises.locale.en_se")}</MenuItem>
      <MenuItem value="en-GB">{t("exercises.locale.en_gb")}</MenuItem>
      <MenuItem value="en-US">{t("exercises.locale.en_us")}</MenuItem>
      <MenuItem value="es-US">{t("exercises.locale.es_us")}</MenuItem>
    </Select>
  );
};
